import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="checkbox-observer"
export default class extends Controller {
  async connect() {
    this.checkbox = this.element.querySelector("input[type='checkbox']");
    this.boundChange = (e) => {
      if (e.target.checked) {
        this.element.classList.add("checked");
      } else {
        this.element.classList.remove("checked");
      }
    };
    this.checkbox.addEventListener("change", this.boundChange);
  }

  disconnect() {
    this.checkbox.removeEventListener("change", this.boundChange);
  }
}
